module.exports = __webpack_public_path__ + "img/CM-AE-25-Honda-Lifestyle.fa32b415.jpg";